webpackJsonp([2],{

/***/ "4C3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_common__ = __webpack_require__("sf/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("meMj");



var state = {
  token: 0
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* CHANGE_TOKEN */], function (state, res) {
  state.token = res;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ "4ml/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AoU9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_common__ = __webpack_require__("sf/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("meMj");




var state = {
  tabIndex: 0
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* CHANGE_TABINDEX */], function (state, res) {
  state.tabIndex = res;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4074ab31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("thlK");
function injectStyle (ssrContext) {
  __webpack_require__("a4pz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4074ab31_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__http_api_js__ = __webpack_require__("m4jk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_less__ = __webpack_require__("nrAE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui__ = __webpack_require__("Au9i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css__ = __webpack_require__("d8/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_lib_index_css__ = __webpack_require__("4ml/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vant_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vant_lib_index_css__);




 //vuex
 //http请求


 //移动端UI

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_mint_ui___default.a);
/* 移动端  有赞  */


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api = __WEBPACK_IMPORTED_MODULE_5__http_api_js__["a" /* default */];

// 用钩子函数beforeEach()对路由进行判断

// router.beforeEach((to, from, next) => {
//   if (to.meta.requireAuth) {  // 需要权限,进一步进行判断
//     if (store.state.login.token) {  // 通过vuex state获取当前的token是否存在
//       next();
//     }
//     else {    //如果没有权限,重定向到登录页,进行登录
//       next({
//         path: '/login',
//         // query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
//       })
//     }
//   }
//   else { //不需要权限 直接跳转
//     next();
//   }
// })


/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
//按需加载,当渲染其他页面时才加载其组件,并缓存,减少首屏加载时间
var Index = function Index(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mlqX")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: '隐私政策',
    component: Index
  }]
}));

/***/ }),

/***/ "YtJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_detail__ = __webpack_require__("yW3m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_category__ = __webpack_require__("AoU9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_login__ = __webpack_require__("4C3y");
//store.js



// 头部分类




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    detail: __WEBPACK_IMPORTED_MODULE_2__modules_detail__["a" /* default */],
    category: __WEBPACK_IMPORTED_MODULE_3__modules_category__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_4__modules_login__["a" /* default */]
  }
}));

/***/ }),

/***/ "a4pz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "m4jk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__ = __webpack_require__("YtJ0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");





var api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
api.defaults.baseURL = 'http://api.com';
api.defaults.timeout = 5000;
api.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
api.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';

// 请求拦截
api.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', true);
    // 如果有token,添加到请求报文 后台会根据该报文返回status
    if (__WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].state.login.token) {
        config.headers.Authorization = 'token ' + __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].state.login.token;
    }

    return config;
}, function (error) {
    // 对请求错误做些什么
    alert('网络错误,请稍后再试');

    __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// 添加响应拦截器
api.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    // 加到时器主要是为了 展示Loading效果 项目中应去除
    setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);
    }, 300);

    return response;
}, function (error) {
    // 对响应错误做点什么
    __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('SET_LOADING', false);

    if (errore.response) {

        if (error.response.status == 401) {
            // 如果返回401 即没有权限，跳到登录页重新登录
            __WEBPACK_IMPORTED_MODULE_2__vuex_store_js__["a" /* default */].commit('CHANGE_TOKEN', 0);

            alert('请重新登录');

            __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({
                path: 'login',
                query: { redirect: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].currentRoute.fullPath }
            });
        }
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),

/***/ "meMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DATAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_COL_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_SIZE_SELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_PRODUCT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_CARLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_COUNT; });
/* unused harmony export SET_SELECTEDLIST */
/* unused harmony export SET_UNSELECTEDLIST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_LOADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_TABINDEX; });
/* Detail + Car*/

//Detail父组件中 当前页面商品的数据

var SET_DATAS = 'SET_DATAS';

//chose组件选择的颜色
var CHANGE_COL_SELECTED = 'CHANGE_COL_SELECTED';

//chose组件选择的尺寸

var CHANGE_SIZE_SELECTED = 'CHANGE_SIZE_SELECTED';

//footer组件中保存添加的商品的数据

var ADD_PRODUCT = 'ADD_PRODUCT';

//footer组件中保存购物车数量的数据

var CHANGE_COUNT = 'CHANGE_COUNT';

//提交订单后重新设置购物车商品列表,把打钩并提交的商品去掉,即保留unSelectedList
var RESET_CARLIST = 'RESET_CARLIST';

//提交订单后重新设置购物车商品数量
var RESET_COUNT = 'RESET_COUNT';

// 购物车里打钩的商品

var SET_SELECTEDLIST = 'SET_SELECTEDLIST';

//购物车里没打钩的商品

var SET_UNSELECTEDLIST = 'SET_UNSELECTEDLIST';

//全局loading状态

var SET_LOADING = 'SET_LOADING';

// 改变token(权限)
var CHANGE_TOKEN = 'CHANGE_TOKEN';

// 分类页的aside index
var CHANGE_TABINDEX = 'CHANGE_TABINDEX';

/***/ }),

/***/ "sf/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var STORAGE_USER_KEY = 'STORAGE_USER_KEY';
// const STORAGE_CARTLIST_KEY = 'STORAGE_CARTLIST_KEY'
// const STORAGE_QUERYMYLIST_KEY = 'STORAGE_QUERYMYLIST_KEY'

/* harmony default export */ __webpack_exports__["a"] = ({
  // 获取
  getLocal: function getLocal() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_USER_KEY;

    // console.log('get local operation')
    return JSON.parse(window.localStorage.getItem(key));
  },

  // 设置用
  setLocal: function setLocal(res) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STORAGE_USER_KEY;
    var isSaveOldData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    //第三个参数是true的话,会增加数据而不是重新设置,res必须是数组
    if (isSaveOldData) {
      if (this.getLocal(key)) {
        var oldData = this.getLocal(key);
        return window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(oldData.concat(res)));
      }
    }
    return window.localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res));
  }
});

/***/ }),

/***/ "thlK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "yW3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_common__ = __webpack_require__("sf/l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("meMj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");


var _mutations;





// 容器
var state = {
  productDatas: '', //detail父组件请求的当前页面商品数据
  colSelected: 0, //0是index,表示第一个
  sizeSelected: 0, //0是index,表示第一个
  count: 0, //购物车里的商品数量
  carList: '', //购物车的商品列表
  fetchLoading: false, //全局加载状态的Loading
  selectedList: '', //已选择的购物车商品列表
  unSelectedList: '' //未选择的购物车商品列表,提交订单后用它替换carList


  //更改 store 中的状态的唯一方法:提交 mutation
  /*
    购物车逻辑:
        unSelectedList：未打钩的购物车商品列表
        SelectedList：已勾选的购物车商品列表
        carList:购物车商品列表
        当支付成功之后,购物车列表需要减掉SelectedList，留下unSelectedList
        直接用unSelectedList替换当前carList即可
  */
};var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_DATAS */], function (state, res) {
  state.productDatas = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* CHANGE_COL_SELECTED */], function (state, res) {
  state.colSelected = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* CHANGE_SIZE_SELECTED */], function (state, res) {
  state.sizeSelected = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["f" /* ADD_PRODUCT */], function (state) {
  state.carList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('carList');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["g" /* CHANGE_COUNT */], function (state) {
  state.count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('count');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["h" /* RESET_CARLIST */], function (state) {
  state.carList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('carList');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["i" /* RESET_COUNT */], function (state) {
  state.count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('carList').length;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["j" /* SET_LOADING */], function (state, res) {
  state.fetchLoading = res;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_SELECTEDLIST', function SET_SELECTEDLIST(state, res) {
  state.selectedList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('selectedList');
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, 'SET_UNSELECTEDLIST', function SET_UNSELECTEDLIST(state) {
  state.unSelectedList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('unSelectedList');
}), _mutations);

var vm = new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({});

// action提交mutations，不直接更改状态（通过store.dispatch触发）
var actions = {

  // 父组件发送异步请求
  setDatas: function setDatas(_ref) {
    var commit = _ref.commit;

    vm.$api({
      method: 'post',
      url: "/detail"
    }).then(function (response) {
      console.log(response, 'detail ====>>>');
      commit('SET_DATAS', response.data);
    });
  },


  // 购物车数量增减,true是加,false是减
  setLocalCount: function setLocalCount(_ref2) {
    var commit = _ref2.commit;
    var bool = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('count') || 0;
    if (bool) {
      __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(++count, 'count');
    } else {
      __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(--count, 'count');
    }
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["g" /* CHANGE_COUNT */]);
  },


  //网购物车列表添加数据
  addCarList: function addCarList(_ref3, res) {
    var commit = _ref3.commit;

    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(res, 'carList', true);
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["f" /* ADD_PRODUCT */]);
  },


  //重新设置购物车商品列表,把打钩并提交的商品去掉,即保留unSelectedList

  resetCarList: function resetCarList(_ref4) {
    var commit = _ref4.commit,
        getters = _ref4.getters;

    var unSelectedList = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('unSelectedList');
    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(unSelectedList, 'carList');
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["h" /* RESET_CARLIST */]);
  },

  // 重置购物车数量Count,即没打钩的商品的数量
  resetCount: function resetCount(_ref5) {
    var commit = _ref5.commit,
        getters = _ref5.getters;

    var count = __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].getLocal('unSelectedList').length;
    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(count, 'count');
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["i" /* RESET_COUNT */]);
  },


  // 删除购物车列表的某一项 （用新的数组直接替换）
  cutCarList: function cutCarList(_ref6, res) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(res, 'carList');
    commit(__WEBPACK_IMPORTED_MODULE_2__types__["h" /* RESET_CARLIST */]);
  },


  // 分别保存打钩的商品和为打钩的商品
  setSelectedList: function setSelectedList(_ref7) {
    var commit = _ref7.commit,
        getters = _ref7.getters;

    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(getters.selectedList, 'selectedList');
    commit('SET_SELECTEDLIST');
    __WEBPACK_IMPORTED_MODULE_1__util_common__["a" /* default */].setLocal(getters.unSelectedList, 'unSelectedList');
    commit('SET_UNSELECTEDLIST');
  }
};

// 如同计算属性,处理state的某个状态
var getters = {
  selectedList: function selectedList(state) {
    // choseBool为真的商品 即打钩的商品
    if (state.carList !== '') {
      var arr = state.carList.filter(function (ele) {
        return ele.choseBool == true;
      });
      return arr;
    }
  },
  unSelectedList: function unSelectedList(state) {
    if (state.carList !== '') {
      var arr = state.carList.filter(function (ele) {
        return ele.choseBool == false;
      });
      return arr;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.8529e8038694cd2950e9.js